(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsFilterBar', rmsFilterBar);

    function rmsFilterBar() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                getQuery: '=',
                resetQuery: '=',
                refreshGrid: '&',
                refresh: '=?',
                setQuery: '=?',
            },
            controller: rmsFilterBarCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/wrapper'
        };
    }

    function rmsFilterBarCtrl(MainFilterBarService, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$id;
            MainFilterBarService.init(vm, vm.filterBarIdentifier, vm.options || {});

            vm.getQuery = function () {
                return vm.filterBarService().getGeneratedQuery();
            };

            vm.resetQuery = function () {
                vm.filterBarService().reset();
            };

            vm.refresh = function () {
                return vm.filterBarService().refresh();
            };

            vm.setQuery = function (filters) {
                vm.filterBarService().setQuery(filters);
            };

            init();

            $scope.$on('$destroy', function () {
                MainFilterBarService.destroy(vm.filterBarIdentifier);
            });
        }

        function init() {
            vm.filterBarService().registerEvent('refreshGrid', vm.refreshGrid);
        }
    }
})();